import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
// create an axios instance
const service = axios.create({
  baseURL: 'https://web.baby161.top', // api 的 base_url
  timeout: 50000 // request timeout
})

service.defaults.withCredentials = true
// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = 'Basic ' + getToken()
    }
    console.log(process.env, '19>>>>>>>>>')
    if (config.params) {
      for (const key in config.params) {
        config.params[key] = config.params[key] === '' ? null : config.params[key]
      }
    }
    return config
  },
  error => {
    console.log(error, '22------------------')
    // Do something with request error
    // console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    // Message({
    //   message: '成功',
    //   type: 'success',
    //   duration: 2000
    // })
    if (response.data.ReturnCode === 200) {
      console.log('45----------------')
      return response.data.Data
    } else {
      Message({
        message: response.data.ErrorMessage,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(response.data.ErrorMessage))
    }
  },
  // response => {
  //   return response.data
  // const res = response.data
  // console.log(res)
  // if (res.code !== 20000) {
  //   Message({
  //     message: res.message,
  //     type: 'error',
  //     duration: 5 * 1000
  //   })
  //   // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
  //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
  //     MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
  //       confirmButtonText: '重新登录',
  //       cancelButtonText: '取消',
  //       type: 'warning'
  //     }).then(() => {
  //       store.dispatch('FedLogOut').then(() => {
  //         location.reload() // 为了重新实例化vue-router对象 避免bug
  //       })
  //     })
  //   }
  //   console.log(1)
  //   return Promise.reject('error')
  // } else {
  //   console.log(2)
  //   return Promise.reject('error')
  // }
  // },
  error => {
    console.log(error, '85------------')
    console.log(error.response.status)
    // console.log(error.response.status)
    // if (error.response.ReturnCode === 403) {
    if (error.response.status === 403) {
      MessageBox.confirm('你已被登出，请重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
      return Promise.reject(error)
    } else {
      Message({
        message: error.response.data.ErrorMessage,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  }
)

export default service
